import { SVGProps } from 'react';
import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import AlertTriangleIcon from '~/components/SVG/AlertTriangle.svg?react';
import { normalizeCssSize } from '~/helpers/utils';

interface AlertTriangleProps extends Omit<SVGProps<SVGSVGElement>, 'ref'> {
  stepStatus?: string;
  index?: number;
  activeStep?: number;
  variant?: 'status' | 'alert';
  size?: number | string;
}

const getStatusStrokeColor = (stepStatus?: string, index?: number, activeStep?: number) => {
  if (stepStatus === 'INVALID_SIGNATURE' || stepStatus === 'MISMATCHED_RNOKPP') {
    return '#FEC53D';
  }

  if (index === activeStep && index != null) {
    return 'common.white';
  }

  return 'primary.main';
};

const isHidden = (stepStatus?: string) => stepStatus === 'NOT_VERIFIED';

const styles = {
  icon:
    (
      variant: 'status' | 'alert',
      stepStatus: string | undefined,
      index: number | undefined,
      activeStep: number | undefined,
      size: number | string | undefined
    ) =>
    (theme: Theme) => ({
      display: isHidden(stepStatus) ? 'none' : 'block',
      flexShrink: 0,
      margin: variant === 'alert' ? '0 auto' : undefined,
      width: normalizeCssSize(size, variant === 'alert' ? '60px' : '20px'),
      height: normalizeCssSize(size, variant === 'alert' ? '60px' : '17px'),
      '& > svg': {
        display: 'block',
        width: '100%',
        height: '100%',
      },
      '& path:nth-of-type(1)': {
        stroke: variant === 'alert' ? theme.palette.error.main : theme.palette.primary.main,
      },
      '& path:nth-of-type(2)': {
        stroke: variant === 'alert' ? theme.palette.error.main : theme.palette.primary.main,
      },
      '& path:nth-of-type(3)': {
        stroke:
          variant === 'alert'
            ? theme.palette.error.main
            : getStatusStrokeColor(stepStatus, index, activeStep),
      },
    }),
};

const AlertTriangle = ({
  stepStatus,
  index,
  activeStep,
  variant = 'status',
  size,
  ...svgProps
}: AlertTriangleProps) => {
  return (
    <Box sx={styles.icon(variant, stepStatus, index, activeStep, size)}>
      <AlertTriangleIcon {...svgProps} />
    </Box>
  );
};

export default AlertTriangle;
